<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <page-header>
      {{ $t('openTime') }}
      <template #subtitle>
        {{ $t('OpeningTimeReservationSub') }}
      </template>
      <template #action>
        <primary-button
          @click="saveAll"
          text="save"
          icon="mdi-content-save"
        />
      </template>
    </page-header>
    <div class="mt-4">
      <loading-provider :loading="loading">
        <div
          v-for="w in weekDayList"
          :key="w.dayOfWeek"
          class="pa-2 mb-2 d-flex align-start"
        >
          <div class="mr-4">
            <div class="text-body-1">
              {{ w.name }}
            </div>
            <div class="d-flex text-body-1 align-center mt-1">
              <v-simple-checkbox
                @click="w.openingTime.length===0?addATime(w.dayOfWeek):w.openingTime=[]"
                :value="w.openingTime.length===0?1:0"
              />
              {{ $t('Close') }}
            </div>
          </div>
          <v-spacer />
          <div>
            <div
              class="d-flex align-center mb-4"
              v-for="(o,i) in w.openingTime"
              :key="o.key"
            >
              <time-selector
                label="ReservationDayStart"
                v-model="o.from"
                class="mr-4"
                style="width: 220px"
              />
              <time-selector
                label="ReservationDayEnd"
                v-model="o.to"
                class="mr-4"
                style="width: 220px"
              />
              <v-text-field
                hide-details
                v-model="o.estimateDiningTimeModifier"
                style="width: 220px"
                class="mr-2"
                outlined
                :label="$t('ReservationDayRuleEdit')"
              >
                <template #append>
                  <div class="text-no-wrap text-body-1">
                    &times;15 min
                  </div>
                </template>
              </v-text-field>
              <v-btn
                v-if="i===0"
                icon
                @click="addATime(w.dayOfWeek)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn
                v-else
                icon
                @click="removeTime(w.dayOfWeek,o.key)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </loading-provider>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import WeekDays from '@/model/dataLayer/api/common/WeekDays'
import { getWeeklySettings, saveWeeklySettings } from '@/model/dataLayer/service/reservation/weeklySetting'
import { timeArrays } from '@/model/dataLayer/api/common/OpenTimeList'
import PrimaryButton from '@/views/AadenPages/components/PrimaryButton.vue'
import TimeSelector from '@/views/AadenPages/settings/reserveSetting/openTime/TimeSelector.vue'

let counter = 8478421
export default {
  name: 'ReservationOpenTime',
  components: {
    TimeSelector,
    PrimaryButton,
    LoadingProvider,
    PageHeader
  },
  data: function () {
    return {
      loading: false,
      weekDayList: [],
      weeklySettingList: []
    }
  },
  computed: {
    timeArrays () {
      return timeArrays
    }

  },
  methods: {
    removeTime (dayOfWeek, id) {
      const list = this.weekDayList.find(w => w.dayOfWeek === dayOfWeek).openingTime
      this.weekDayList.find(w => w.dayOfWeek === dayOfWeek).openingTime = list.filter(it => it.key !== id)
    },
    addATime (dayOfWeek) {
      this.weekDayList.find(w => w.dayOfWeek === dayOfWeek).openingTime
        .push(this.creatDefaultOpeningTimeSpan())
    },
    creatDefaultOpeningTimeSpan () {
      return {
        key: counter++,
        estimateDiningTimeModifier: 0,
        from: '11:00',
        to: '23:00'
      }
    },
    async saveAll () {
      this.loading = true
      for (const it of this.weekDayList) {
        it.openingTimeSpan = it.openingTime
        await saveWeeklySettings(it)
      }
      this.reload()
      this.loading = false
    },
    async reload () {
      this.weeklySettingList = await getWeeklySettings()
      console.log(this.weeklySettingList, 'list')
      this.weekDayList = WeekDays.getList().map(it => {
        return {
          dayOfWeek: it.id,
          name: it.name,
          openingTime: this.weeklySettingList.find(w => w.dayOfWeek === it.id)?.openingTimeSpan ?? [
            this.creatDefaultOpeningTimeSpan()
          ]
        }
      }
      )
    }
  },
  mounted () {
    this.reload()
  }
}
</script>

<style scoped>

</style>
